export default __webpack_public_path__ + "static/media/Globe.b4c9a5d9.svg";